
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import moment from 'moment';
    import commonService from '@/services/common-services';
    import utility from '@/utility/utility';
    import commentServices from '@/services/comment-services';
    import { Comment } from '@/models/comment';
    import { APP_CONFIG } from '@/config/app-config'
    import Loading from 'vue-loading-overlay';
    @Component({
        components: {
            Loading
        }
    })
    export default class ChatBox extends Vue {
        @Prop({default: 0})
        private orderId!: number;

        @Prop({default: 1})
        private orderType!: number;
        private hasImage = false;
        private imageData: any = null;
        private uploadValue = 100;
        private comment: string = '';
        private listComment: Comment[] = [];
        private timer: any;

        private isBlockEnter = false;

        get userInfo() {
            return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
        }

        private async created() {
            this.timer = setInterval(() => {
                this.loadComment();
            }, APP_CONFIG.notifyRefreshTime * 1000);
        }

        private async destroyed() {
            clearInterval(this.timer);
        }

        @Watch('orderId', { immediate: true, deep: true })
        private async loadComment() {
            if (this.orderId > 0) {
                const result: any = await commentServices.getComment(this.orderId, this.orderType);
                if(result && result.data.status === 200 && result.data.message === 'Success') {
                    const arrComment: any = [];
                    for (const item of result.data.data) {
                        arrComment.push({
                            ...item,
                            CreatedDate: moment(item.CreatedDate).format('DD-MM-YYYY hh:mm:ss')
                        });
                    }

                    this.listComment = arrComment;
                }
                this.setScroll();
            }
        }

        private onCommentKeyup(e: any) {
            if(e.keyCode === 13) {
                e.preventDefault();
                this.addComment();
            }
        }
        
        private async addComment() {
            if (this.comment.trim().length > 0 && this.isBlockEnter === false) {
                this.isBlockEnter = true;
                const commentModel: Comment = {
                    OrderID: this.orderId,
                    Comment: this.comment,
                    Status: 1,
                    Type: 1,
                    OrderType: this.orderType,
                    CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId
                };
                const result = await commentServices.addComment(commentModel);
                this.comment = '';
                this.isBlockEnter = false;
                if (result.data.status === 200) {
                    this.loadComment();
                }
            }
        }

        private setScroll() {
            setTimeout(() => {
                const boxMess: any = this.$el.querySelector('.content-message');
                boxMess.scrollTop = boxMess.scrollHeight;
            }, 0);
        }

        private async onChangeFile(event: any) {
            if (event.target.files && event.target.files[0]) {
                const files = event.target.files;
                for (const file of files) {
                    this.addFile(file, file.type.indexOf('image') !== -1 ? 1 : 2);
                }
            }
        }

        private async addFile(output, mediaType) {
            if(this.uploadValue === 100) {
                this.uploadValue = 0;
                this.hasImage = true;
                this.imageData = output;
                this.onUpload(mediaType);
            }
        }

        private async onUpload(mediaType) {
            const arrFileType = this.imageData.name.split('.');
            const ext = arrFileType[arrFileType.length - 1];
            const formData = new FormData();
            formData.append('imagefile', this.imageData);
            formData.append('filename', `${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}`);
            formData.append('extension', ext);
            const ret = await commonService.uploadFile(formData);
            this.uploadValue = 100;
            this.isBlockEnter = false;
            if(ret.status===200) {
                const commentModel: Comment = {
                    OrderID: this.orderId,
                    FileName: this.imageData.name,
                    Comment: ret.data.data,
                    Status: 1,
                    Type: 1,
                    OrderType: this.orderType,
                    CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId,
                    Media: mediaType
                };
                const result = await commentServices.addComment(commentModel);
                this.comment = '';
                if (result.data.status === 200) {
                    this.loadComment();
                }
            }
        }

        private async onPaste(event) {
            this.isBlockEnter = true;
            const clipboardData = event.clipboardData || window['clipboardData'];
            const items = clipboardData.items;
            for (const item of items) {
                const imageFile = item.getAsFile();
                this.addFile(imageFile, item.type.indexOf('image') !== -1 ? 1 : 2);
            }
        }
    }
